import React from 'react';
import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Events } from '@elyx-code/common-ts-utils';
import { envConfig } from './config';
import Router from './Router';
import './main.css';
import { Amplify } from 'aws-amplify';
import { theme } from './theme';
import { Socket } from './socket/socket';

Amplify.configure(envConfig.amplifyConfig);

export const SOCKET: Socket = new Socket({
	socketUrl: envConfig.WS_URL,
});

export const EVENTS = new Events('app-events');

const App: React.FC = () => {
  return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<ThemeProvider theme={theme}>
				<Router socket={SOCKET} events={EVENTS} />
			</ThemeProvider>
		</LocalizationProvider>
	);
}

export default App;
